import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const phiDescriptor = {
    a: TD.inlet(TD.Identity<any>()),
    b: TD.inlet(TD.Identity<any>()),
    output: TD.outlet(TD.Identity<any>()),
}

export class Phi<T> implements NodeClassImpl<typeof phiDescriptor, typeof Phi> {
    static descriptor = phiDescriptor
    static uniqueName = "Phi"
    a!: Inlet<T>
    b!: Inlet<T>
    output!: Outlet<T>

    run() {
        if (this.a !== NotReady) {
            this.output.emitIfChanged(this.a)
        } else if (this.b !== NotReady) {
            this.output.emitIfChanged(this.b)
        } else {
            this.output.emitIfChanged(NotReady)
        }
    }
}
